<div class="wrapper">
	<!-- <button (click)="stockManager()">Stock manager</button> -->
	<!-- <button (click)="openDialog()">open modal</button> -->
	<app-manager-header
		[venue]=" venue$  | async"
		[showFaq]="true"
		[showChip]="true"
	></app-manager-header>

	<app-table-list-draw></app-table-list-draw>

	@if((venue$ | async)?.externalOrderProviders) {

	<div class="status-order-providers">
		@if(venue$ | async; as venue) { @if(checkIfSetupOrderProviders(venue,
		'uber_eat')) {

		<app-status-order-providers
			img="../../../assets/logos/uber-eats.webp"
			status="Online"
			[online]="(statusUber$ | async)!.isActive"
		></app-status-order-providers>
		} @if(checkIfSetupOrderProviders(venue, 'wolt')) {

		<app-status-order-providers
			img="../../../assets/logos/wolt.webp"
			status="Online"
			[online]="(statusWolt$ | async)!.isActive"
		></app-status-order-providers>
		} }
	</div>
	}

	<div class="order-container" #scrollableContent>
		@for (order of (orders$ | async); track order?._id) {

		<app-manager-order-item-draw
			[order]="order"
			[venue]="venue$ | async"
			[updateStatusLoading]="updateStatusLoading$ | async"
			(sendOrderPoolStatusChange)="updateStatusOrderPool($event)"
			(sendOrderStatusChange)="updateStatus($event)"
		>
		</app-manager-order-item-draw>

		}
	</div>
	<div class="nav-buttons">
		<button mat-icon-button class="scroll-btn left" (click)="scrollLeft()">
			<mat-icon>chevron_left</mat-icon>
		</button>
		<button mat-icon-button class="scroll-btn right" (click)="scrollRight()">
			<mat-icon>chevron_right</mat-icon>
		</button>
	</div>
</div>
